import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Bounce, toast } from "react-toastify";
import api from "../api";
import "./associazioni.css";

const EditAssociazione = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [associazione, setAssociazione] = useState(null);
  const [original, setOriginal] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isEditing, setIsEditing] = useState(false);
  const [inputErrors, setInputErrors] = useState({});
  const [modalTrainer, setModalTrainer] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [activeModalTab, setActiveModalTab] = useState("anagrafica");

  const noteRef = useRef(null);

  const fetchAssociazione = async () => {
    try {
      const res = await api.get(`/associazioni/${id}`);
      if (res.status === 200) {
        setAssociazione(res.data);
        setOriginal(res.data);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message, {
        transition: Bounce,
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const userRole = localStorage.getItem("userRole");

    if (userRole !== "ADMIN") {
      alert("Accedi come amministratore per modificare le associazioni!");
      localStorage.clear();
      navigate("/login");
    } else {
      fetchAssociazione();
    }
  }, [navigate]);

  const isValid = () => {
    const errors = {};
    if (!associazione.note || associazione.note.trim().length < 2) {
      errors.note = "Le note devono contenere almeno 2 caratteri.";
    }
    setInputErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setAssociazione((prev) => ({ ...prev, [name]: value }));
    setInputErrors((prevErrors) => ({ ...prevErrors, [name]: undefined }));
  };

  const handleSave = async () => {
    if (!isValid()) return;

    const payload = {
      ricercaId: associazione.ricerca?.idRicerca,
      trainerId: associazione.trainer?.id,
      note: associazione.note || "",
    };

    try {
      const res = await api.put(`/associazioni/${id}`, payload);
      if (res.status === 200) {
        toast.success("Associazione aggiornata con successo", {
          transition: Bounce,
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        setOriginal(associazione);
        setIsEditing(false);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message, {
        transition: Bounce,
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  };

  const handleCancel = () => {
    setAssociazione(original);
    setIsEditing(false);
  };

  const closeModal = () => {
    setModalTrainer(null);
    setShowModal(false);
  };

  function formatDate(dateString) {
    if (!dateString) return "";

    const date = new Date(dateString);
    if (isNaN(date)) return "";

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}.${month}.${year}`;
  }

  const modalTabs = [
    { key: "anagrafica", label: "Anagrafica" },
    { key: "interviste", label: "Interviste" },
    { key: "esperienze", label: "Esperienze Lavorative" },
    { key: "candidature", label: "Candidature" },
    { key: "simulazioni", label: "Simulazioni" },
    { key: "moduli", label: "Moduli Protocollati" },
    { key: "accordo", label: "Accordo Quadro" },
    { key: "ricerca", label: "Ricerca Associata" },
  ];

  useEffect(() => {
    const fetchTrainer = async () => {
      try {
        setLoading(true);
        const res = await api.get(`/trainers/${associazione?.trainer?.id}`);
        if (res.status === 200) {
          setModalTrainer(res.data);
        }
      } catch (error) {
        console.error(error);
        toast.error(error?.response?.data?.message, {
          transition: Bounce,
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      } finally {
        setLoading(false);
      }
    };

    if (showModal) {
      fetchTrainer();
    }
  }, [showModal, associazione?.trainer?.id]);

  return (
    <div className="content-page">
      {loading && (
        <div className="overlay">
          <div className="spinner"></div>
        </div>
      )}

      <div className="page-header">
        <div className="page-title">
          <i className="fa-solid fa-edit"></i>
          Modifica Associazione
        </div>
        <div className="controls">
          <button
            onClick={() => navigate("/associazioni")}
            className="back-btn"
          >
            <i className="fa-solid fa-arrow-left"></i>
            Torna alle Associazioni
          </button>
        </div>
      </div>

      <div className="page-content edit-associazioni-container">
        {associazione && (
          <div className="details-card">
            <div className="card-header">
              <div className="card-title">
                <i className="fa-solid fa-link"></i>
                Dettagli Associazione #{associazione.idAssociazione}
              </div>
              <div className="card-actions">
                {!isEditing && (
                  <button
                    className="edit-btn"
                    onClick={() => {
                      setIsEditing(true);
                      setTimeout(() => {
                        noteRef.current?.scrollIntoView({
                          behavior: "smooth",
                          block: "center",
                        });
                        noteRef.current?.focus();
                      }, 0);
                    }}
                  >
                    <i className="fa-solid fa-edit"></i>
                    Modifica Note
                  </button>
                )}
              </div>
            </div>

            <div className="card-content">
              <div className="info-sections">
                <div className="info-section">
                  <div className="section-header">
                    <i className="fa-solid fa-info-circle"></i>
                    Informazioni Generali
                  </div>
                  <div className="info-grid">
                    <div className="info-item">
                      <label className="info-label">ID Associazione:</label>
                      <span className="info-value">
                        {associazione.idAssociazione}
                      </span>
                    </div>
                    <div className="info-item">
                      <label className="info-label">Docente ID:</label>
                      <span className="info-value">
                        {associazione.trainer?.id}
                      </span>
                    </div>
                    <div className="info-item">
                      <label className="info-label">Ricerca ID:</label>
                      <span className="info-value">
                        {associazione.ricerca?.idRicerca}
                      </span>
                    </div>
                  </div>
                </div>

                <div className="info-section">
                  <div className="section-header">
                    <i className="fa-solid fa-search"></i>
                    Dati Ricerca
                  </div>
                  <div className="info-grid">
                    <div className="info-item">
                      <label className="info-label">Autore:</label>
                      <span className="info-value">
                        {associazione.ricerca?.autore || "-"}
                      </span>
                    </div>
                    <div className="info-item">
                      <label className="info-label">Data Creazione:</label>
                      <span className="info-value">
                        {formatDate(associazione.ricerca?.dataCreazione)}
                      </span>
                    </div>
                    <div className="info-item">
                      <label className="info-label">Titolo Corso:</label>
                      <span className="info-value">
                        {associazione.ricerca?.titoloCorso || "-"}
                      </span>
                    </div>
                    <div className="info-item">
                      <label className="info-label">Titolo Modulo:</label>
                      <span className="info-value">
                        {associazione.ricerca?.titoloModulo || "-"}
                      </span>
                    </div>
                  </div>
                </div>

                <div className="info-section">
                  <div className="section-header">
                    <i className="fa-solid fa-user-tie"></i>
                    Dati Docente
                  </div>
                  <div className="info-grid">
                    <div className="info-item">
                      <label className="info-label">Nome:</label>
                      <span className="info-value">
                        {associazione.trainer?.nome || "-"}
                      </span>
                    </div>
                    <div className="info-item">
                      <label className="info-label">Cognome:</label>
                      <span className="info-value">
                        {associazione.trainer?.cognome || "-"}
                      </span>
                    </div>
                    <div className="info-item">
                      <label className="info-label">Email:</label>
                      <span className="info-value">
                        {associazione.trainer?.email || "-"}
                      </span>
                    </div>
                    <div className="info-item">
                      <label className="info-label">Codice Fiscale:</label>
                      <span className="info-value">
                        {associazione.trainer?.codiceFiscale || "-"}
                      </span>
                    </div>
                    <div className="info-item">
                      <label className="info-label">Stato Occupazionale:</label>
                      <span className="info-value">
                        {associazione.trainer?.statoOccupazionale || "-"}
                      </span>
                    </div>
                  </div>
                  <button
                    onClick={() => setShowModal(true)}
                    className="full-details"
                  >
                    Docenti dettagli
                  </button>
                </div>

                <div className="info-section">
                  <div className="section-header">
                    <i className="fa-solid fa-sticky-note"></i>
                    Note
                  </div>
                  <div className="notes-section">
                    {!isEditing ? (
                      <div className="notes-display">
                        <span className="notes-text">
                          {associazione.note || "Nessuna nota disponibile"}
                        </span>
                      </div>
                    ) : (
                      <div className="notes-edit">
                        <textarea
                          id="note"
                          name="note"
                          value={associazione.note || ""}
                          onChange={handleChange}
                          className="modern-textarea"
                          placeholder="Inserisci le note per questa associazione..."
                          rows={4}
                          ref={noteRef}
                        />
                        {inputErrors.note && (
                          <span className="error-message">
                            <i className="fa-solid fa-exclamation-circle"></i>
                            {inputErrors.note}
                          </span>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {isEditing && (
                <div className="edit-actions">
                  <button className="btn-secondary" onClick={handleCancel}>
                    <i className="fa-solid fa-times"></i>
                    Annulla
                  </button>
                  <button className="btn-primary" onClick={handleSave}>
                    <i className="fa-solid fa-save"></i>
                    Salva Modifiche
                  </button>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
      {showModal && modalTrainer && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-title">Dettagli del docente</div>
            <button className="close-modal" onClick={closeModal}>
              <i className="fa-solid fa-xmark"></i>
            </button>

            {/* Modal Tabs */}
            <div className="modal-tabs">
              {modalTabs.map((tab) => (
                <button
                  key={tab.key}
                  className={`modal-tab-btn${
                    activeModalTab === tab.key ? " active" : ""
                  }`}
                  onClick={() => setActiveModalTab(tab.key)}
                >
                  {tab.label}
                </button>
              ))}
            </div>

            {/* Tab Content */}
            <div className="modal-tab-content">
              {/* Anagrafica Tab */}
              {activeModalTab === "anagrafica" && (
                <div className="trainer-data-section">
                  <div className="trainer-data-secton-title">
                    Docente anagrafica
                  </div>
                  <div className="trainer-data-section-content">
                    <div className="data-group">
                      <div className="data-label">Nome e cognome: </div>
                      <div className="data-value">
                        <span className="value">
                          {modalTrainer.anagrafica.nome}
                          {modalTrainer.anagrafica.cognome}
                        </span>
                      </div>
                    </div>
                    <div className="data-group">
                      <div className="data-label">Codice Fiscale: </div>
                      <div className="data-value">
                        <span className="value">
                          {modalTrainer.anagrafica.codiceFiscale}
                        </span>
                      </div>
                    </div>
                    <div className="data-group">
                      <div className="data-label">Email: </div>
                      <div className="data-value">
                        <span className="value">
                          {modalTrainer.anagrafica.email}
                        </span>
                      </div>
                    </div>
                    <div className="data-group">
                      <div className="data-label">Cellulare: </div>
                      <div className="data-value">
                        <span className="value">
                          {modalTrainer.anagrafica.cellulare}
                        </span>
                      </div>
                    </div>
                    <div className="data-group">
                      <div className="data-label">Città Di Residenza: </div>
                      <div className="data-value">
                        <span className="value">
                          {modalTrainer.anagrafica.cittàDiResidenza}
                        </span>
                      </div>
                    </div>
                    <div className="data-group">
                      <div className="data-label">Via: </div>
                      <div className="data-value">
                        <span className="value">
                          {modalTrainer.anagrafica.via}
                        </span>
                      </div>
                    </div>
                    <div className="data-group">
                      <div className="data-label">Provincia: </div>
                      <div className="data-value">
                        <span className="value">
                          {modalTrainer.anagrafica.provincia}
                        </span>
                      </div>
                    </div>
                    <div className="data-group">
                      <div className="data-label">Sesso: </div>
                      <div className="data-value">
                        <span className="value">
                          {modalTrainer.anagrafica.sesso}
                        </span>
                      </div>
                    </div>
                    <div className="data-group">
                      <div className="data-label">Data Di Nascita: </div>
                      <div className="data-value">
                        <span className="value">
                          {formatDate(modalTrainer.anagrafica.dataDiNascita)}
                        </span>
                      </div>
                    </div>
                    <div className="data-group">
                      <div className="data-label">Stato Occupazionale: </div>
                      <div className="data-value">
                        <span className="value">
                          {modalTrainer.anagrafica.statoOccupazionale}
                        </span>
                      </div>
                    </div>
                    <div className="data-group">
                      <div className="data-label">Livello Inglese: </div>
                      <div className="data-value">
                        <span className="value">
                          {modalTrainer.anagrafica.livelloInglese}
                        </span>
                      </div>
                    </div>
                    <div className="data-group">
                      <div className="data-label">Livello Informatica: </div>
                      <div className="data-value">
                        <span className="value">
                          {modalTrainer.anagrafica.livelloInformatica}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Interviste Tab */}
              {activeModalTab === "interviste" &&
                modalTrainer.interviste.length > 0 && (
                  <div className="trainer-data-section">
                    <div className="trainer-data-secton-title">Interviste</div>
                    {modalTrainer.interviste.length > 0 &&
                      modalTrainer.interviste?.map((intervista, index) => (
                        <div
                          className="trainer-data-section-content"
                          key={index}
                        >
                          <div className="data-group">
                            <div className="data-label">Data Intervista: </div>
                            <div className="data-value">
                              <span className="value">
                                {formatDate(intervista.dataIntervista)}
                              </span>
                            </div>
                          </div>
                          <div className="data-group">
                            <div className="data-label">Parlantina: </div>
                            <div className="data-value">
                              <span className="value">
                                {intervista.parlantina ? "Si" : "No"}
                              </span>
                            </div>
                          </div>
                          <div className="data-group">
                            <div className="data-label">Timidezza: </div>
                            <div className="data-value">
                              <span className="value">
                                {intervista.timidezza ? "Si" : "No"}
                              </span>
                            </div>
                          </div>
                          <div className="data-group">
                            <div className="data-label">Dinamicità: </div>
                            <div className="data-value">
                              <span className="value">
                                {intervista.dinamicità ? "Si" : "No"}
                              </span>
                            </div>
                          </div>
                          <div className="data-group">
                            <div className="data-label">Empatia: </div>
                            <div className="data-value">
                              <span className="value">
                                {intervista.empatia}
                              </span>
                            </div>
                          </div>
                          <div className="data-group">
                            <div className="data-label">Inglese: </div>
                            <div className="data-value">
                              <span className="value">
                                {intervista.inglese}
                              </span>
                            </div>
                          </div>
                          <div className="data-group">
                            <div className="data-label">
                              Adeguato Insegnamento:{" "}
                            </div>
                            <div className="data-value">
                              <span className="value">
                                {intervista.adeguatoInsegnamento}
                              </span>
                            </div>
                          </div>
                          <div className="data-group">
                            <div className="data-label">Automunito: </div>
                            <div className="data-value">
                              <span className="value">
                                {intervista.automunito ? "Si" : "No"}
                              </span>
                            </div>
                          </div>
                          <div className="data-group">
                            <div className="data-label">Piva: </div>
                            <div className="data-value">
                              <span className="value">
                                {intervista.piva ? "Si" : "No"}
                              </span>
                            </div>
                          </div>
                          <div className="data-group">
                            <div className="data-label">
                              Luogo Lavorativo Desiderato:{" "}
                            </div>
                            <div className="data-value">
                              <span className="value">
                                {intervista.luogoLavorativoDesiderato}
                              </span>
                            </div>
                          </div>
                          {intervista.annotazioneInterna && (
                            <div className="data-group">
                              <div className="data-label">
                                Annotazione Interna:{" "}
                              </div>
                              <div className="data-value">
                                <span className="value">
                                  {intervista.annotazioneInterna}
                                </span>
                              </div>
                            </div>
                          )}
                          <div className="data-group">
                            <div className="data-label">
                              Punteggio Intervista:{" "}
                            </div>
                            <div className="data-value">
                              <span className="value">
                                {intervista.punteggioIntervista}
                              </span>
                            </div>
                          </div>
                          <div className="data-group">
                            <div className="data-label">Autore: </div>
                            <div className="data-value">
                              <span className="value">{intervista.autore}</span>
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                )}

              {/* Esperienze Lavorative Tab */}
              {activeModalTab === "esperienze" &&
                modalTrainer.esperienzeLavorative.length > 0 && (
                  <div className="trainer-data-section">
                    <div className="trainer-data-secton-title">
                      Esperienze Lavorative
                    </div>
                    {modalTrainer.esperienzeLavorative.length > 0 &&
                      modalTrainer.esperienzeLavorative?.map((esp, index) => (
                        <div
                          className="trainer-data-section-content"
                          key={index}
                        >
                          <div className="data-group">
                            <div className="data-label">Ruolo: </div>
                            <div className="data-value">
                              <span className="value">{esp.ruolo}</span>
                            </div>
                          </div>
                          <div className="data-group">
                            <div className="data-label">Nome Mansione: </div>
                            <div className="data-value">
                              <span className="value">
                                {esp.mansione.nomeMansione}
                              </span>
                            </div>
                          </div>
                          <div className="data-group">
                            <div className="data-label">Dal: </div>
                            <div className="data-value">
                              <span className="value">
                                {formatDate(esp.dal)}
                              </span>
                            </div>
                          </div>
                          <div className="data-group">
                            <div className="data-label">Al: </div>
                            <div className="data-value">
                              <span className="value">
                                {formatDate(esp.al)}
                              </span>
                            </div>
                          </div>
                          <div className="data-group">
                            <div className="data-label">Nome Azienda: </div>
                            <div className="data-value">
                              <span className="value">{esp.nomeAzienda}</span>
                            </div>
                          </div>
                          <div className="data-group">
                            <div className="data-label">
                              Descrizione Ruolo:{" "}
                            </div>
                            <div className="data-value">
                              <span className="value">
                                {esp.descrizioneRuolo}
                              </span>
                            </div>
                          </div>
                          <div className="data-group">
                            <div className="data-label">
                              Conteggio Esperienza:{" "}
                            </div>
                            <div className="data-value">
                              <span className="value">
                                {esp.conteggioEsperienza}
                              </span>
                            </div>
                          </div>
                          <div className="data-group">
                            <div className="data-label">Data Creazione: </div>
                            <div className="data-value">
                              <span className="value">
                                {formatDate(esp.dataCreazione)}
                              </span>
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                )}

              {/* Candidature Tab */}
              {activeModalTab === "candidature" &&
                modalTrainer.candidature.length > 0 && (
                  <div className="trainer-data-section">
                    <div className="trainer-data-secton-title">Candidature</div>
                    {modalTrainer.candidature.length > 0 &&
                      modalTrainer.candidature?.map((candidatura, index) => (
                        <div
                          className="trainer-data-section-content"
                          key={index}
                        >
                          <div className="data-group">
                            <div className="data-label">Data Candidatura: </div>
                            <div className="data-value">
                              <span className="value">
                                {formatDate(candidatura.dataCandidatura)}
                              </span>
                            </div>
                          </div>
                          <div className="data-group">
                            <div className="data-label">Esito: </div>
                            <div className="data-value">
                              <span className="value">{candidatura.esito}</span>
                            </div>
                          </div>
                          {candidatura.descrizioneEsito && (
                            <div className="data-group">
                              <div className="data-label">
                                Descrizione Esito:{" "}
                              </div>
                              <div className="data-value">
                                <span className="value">
                                  {candidatura.descrizioneEsito}
                                </span>
                              </div>
                            </div>
                          )}
                          {modalTrainer.candidature.dataEsito && (
                            <div className="data-group">
                              <div className="data-label">Data Esito: </div>
                              <div className="data-value">
                                <span className="value">
                                  {formatDate(candidatura.dataEsito)}
                                </span>
                              </div>
                            </div>
                          )}
                          <div className="data-group">
                            <div className="data-label">Titolo Modulo: </div>
                            <div className="data-value">
                              <span className="value">
                                {candidatura.titoloModulo}
                              </span>
                            </div>
                          </div>
                          <div className="data-group">
                            <div className="data-label">Sede Indirizzo: </div>
                            <div className="data-value">
                              <span className="value">
                                {candidatura.sedeIndirizzo}
                              </span>
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                )}

              {/* Simulazioni Tab */}
              {activeModalTab === "simulazioni" &&
                modalTrainer.simulazioni.length > 0 && (
                  <div className="trainer-data-section">
                    <div className="trainer-data-secton-title">Simulazioni</div>
                    {modalTrainer.simulazioni.length > 0 &&
                      modalTrainer.simulazioni?.map((simulazione, index) => (
                        <div
                          className="trainer-data-section-content"
                          key={index}
                        >
                          <div className="data-group">
                            <div className="data-label">Data Inserimento: </div>
                            <div className="data-value">
                              <span className="value">
                                {formatDate(simulazione.dataInserimento)}
                              </span>
                            </div>
                          </div>
                          <div className="data-group">
                            <div className="data-label">Link: </div>
                            <div className="data-value">
                              <span className="value">
                                <a
                                  href={simulazione.link}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  {simulazione.link}
                                </a>
                              </span>
                            </div>
                          </div>
                          <div className="data-group">
                            <div className="data-label">Autore: </div>
                            <div className="data-value">
                              <span className="value">
                                {simulazione.autore}
                              </span>
                            </div>
                          </div>
                          <div className="data-group">
                            <div className="data-label">Data Inserimento: </div>
                            <div className="data-value">
                              <span className="value">
                                {formatDate(simulazione.dataInserimento)}
                              </span>
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                )}

              {/* Moduli Protocollati Tab */}
              {activeModalTab === "moduli" &&
                modalTrainer.moduliProtocollati.length > 0 && (
                  <div className="trainer-data-section">
                    <div className="trainer-data-secton-title">
                      Moduli Protocollati
                    </div>
                    {modalTrainer.moduliProtocollati.length > 0 &&
                      modalTrainer.moduliProtocollati?.map((moduli, index) => (
                        <div
                          className="trainer-data-section-content"
                          key={index}
                        >
                          <div className="data-group">
                            <div className="data-label">Data Creazione: </div>
                            <div className="data-value">
                              <span className="value">
                                {formatDate(moduli.dataCreazione)}
                              </span>
                            </div>
                          </div>
                          <div className="data-group">
                            <div className="data-label">Titolo Modulo: </div>
                            <div className="data-value">
                              <span className="value">
                                {moduli.titoloModulo}
                              </span>
                            </div>
                          </div>
                          <div className="data-group">
                            <div className="data-label">Ore Modulo: </div>
                            <div className="data-value">
                              <span className="value">{moduli.oreModulo}</span>
                            </div>
                          </div>
                          <div className="data-group">
                            <div className="data-label">
                              Modalità Erogazione:{" "}
                            </div>
                            <div className="data-value">
                              <span className="value">
                                {moduli.modalitàErogazione}
                              </span>
                            </div>
                          </div>
                          <div className="data-group">
                            <div className="data-label">
                              Materiale Attrezzature:{" "}
                            </div>
                            <div className="data-value">
                              <span className="value">
                                {moduli.materialeAttrezzature}
                              </span>
                            </div>
                          </div>
                          <div className="data-group">
                            <div className="data-label">
                              Previste Dispense:{" "}
                            </div>
                            <div className="data-value">
                              <span className="value">
                                {moduli.previsteDispense}
                              </span>
                            </div>
                          </div>
                          <div className="data-group">
                            <div className="data-label">Prove Finali: </div>
                            <div className="data-value">
                              <span className="value">
                                {moduli.proveFinali}
                              </span>
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                )}

              {/* Accordo Quadro Tab */}
              {activeModalTab === "accordo" &&
                modalTrainer.accordoQuadro.length > 0 && (
                  <div className="trainer-data-section">
                    <div className="trainer-data-secton-title">
                      Accordo Quadro
                    </div>
                    {modalTrainer.accordoQuadro.length > 0 &&
                      modalTrainer.accordoQuadro?.map((accordo, index) => (
                        <div
                          className="trainer-data-section-content"
                          key={index}
                        >
                          <div className="data-group">
                            <div className="data-label">Data Accordo: </div>
                            <div className="data-value">
                              <span className="value">
                                {formatDate(accordo.dataAccordo)}
                              </span>
                            </div>
                          </div>
                          <div className="data-group">
                            <div className="data-label">
                              Tipologia Accordo:{" "}
                            </div>
                            <div className="data-value">
                              <span className="value">
                                {accordo.tipologiaAccordo}
                              </span>
                            </div>
                          </div>
                          <div className="data-group">
                            <div className="data-label">Quota Da Sistema: </div>
                            <div className="data-value">
                              <span className="value">
                                {accordo.quotaDaSistema}
                              </span>
                            </div>
                          </div>
                          <div className="data-group">
                            <div className="data-label">Livello Accordo: </div>
                            <div className="data-value">
                              <span className="value">
                                {accordo.livelloAccordo}
                              </span>
                            </div>
                          </div>
                          <div className="data-group">
                            <div className="data-label">Quota Oraria: </div>
                            <div className="data-value">
                              <span className="value">
                                {accordo.quotaOraria}
                              </span>
                            </div>
                          </div>
                          <div className="data-group">
                            <div className="data-label">Importo Definito: </div>
                            <div className="data-value">
                              <span className="value">
                                {accordo.importoDefinito}
                              </span>
                            </div>
                          </div>
                          <div className="data-group">
                            <div className="data-label">
                              Data Prossimo Aggiornamento:
                            </div>
                            <div className="data-value">
                              <span className="value">
                                {formatDate(accordo.dataProssimoAggiornamento)}
                              </span>
                            </div>
                          </div>
                          <div className="data-group">
                            <div className="data-label">Autore:</div>
                            <div className="data-value">
                              <span className="value">{accordo.autore}</span>
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                )}

              {/* Ricerca Associata Tab */}
              {activeModalTab === "ricerca" &&
                modalTrainer?.ricercaAssociata?.length > 0 && (
                  <div className="trainer-data-section">
                    <div className="trainer-data-secton-title">
                      Ricerca Associata
                    </div>
                    {modalTrainer?.ricercaAssociata?.length > 0 &&
                      modalTrainer.ricercaAssociata.map((ricerca, index) => (
                        <div
                          className="trainer-data-section-content"
                          key={index}
                        >
                          <div className="data-group">
                            <div className="data-label">Titolo Corso: </div>
                            <div className="data-value">
                              <span className="value">
                                {ricerca.titoloCorso}
                              </span>
                            </div>
                          </div>
                          <div className="data-group">
                            <div className="data-label">Titolo Modulo: </div>
                            <div className="data-value">
                              <span className="value">
                                {ricerca.titoloModulo}
                              </span>
                            </div>
                          </div>
                          <div className="data-group">
                            <div className="data-label">Ore: </div>
                            <div className="data-value">
                              <span className="value">{ricerca.ore}</span>
                            </div>
                          </div>
                          <div className="data-group">
                            <div className="data-label">Stato Ricerca: </div>
                            <div className="data-value">
                              <span className="value">
                                {ricerca.statoRicerca}
                              </span>
                            </div>
                          </div>
                          <div className="data-group">
                            <div className="data-label">Data Creazione: </div>
                            <div className="data-value">
                              <span className="value">
                                {formatDate(ricerca.dataCreazione)}
                              </span>
                            </div>
                          </div>
                          <div className="data-group">
                            <div className="data-label">Autore: </div>
                            <div className="data-value">
                              <span className="value">{ricerca.autore}</span>
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                )}

              {/* Empty State */}
              {activeModalTab !== "anagrafica" &&
                ((activeModalTab === "interviste" &&
                  modalTrainer.interviste.length === 0) ||
                  (activeModalTab === "esperienze" &&
                    modalTrainer.esperienzeLavorative.length === 0) ||
                  (activeModalTab === "candidature" &&
                    modalTrainer.candidature.length === 0) ||
                  (activeModalTab === "simulazioni" &&
                    modalTrainer.simulazioni.length === 0) ||
                  (activeModalTab === "moduli" &&
                    modalTrainer.moduliProtocollati.length === 0) ||
                  (activeModalTab === "accordo" &&
                    modalTrainer.accordoQuadro.length === 0) ||
                  (activeModalTab === "ricerca" &&
                    (!modalTrainer?.ricercaAssociata ||
                      modalTrainer.ricercaAssociata.length === 0))) && (
                  <div className="trainer-data-section">
                    <div className="trainer-data-secton-title">
                      {
                        modalTabs.find((tab) => tab.key === activeModalTab)
                          ?.label
                      }
                    </div>
                    <div className="trainer-data-section-content">
                      <div className="data-group">
                        <div className="data-value">
                          <span
                            className="value"
                            style={{
                              textAlign: "center",
                              width: "100%",
                              color: "#6c757d",
                              fontStyle: "italic",
                            }}
                          >
                            Nessun dato disponibile per questa sezione
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default EditAssociazione;
